import { type IThemeRootProviderProps } from '@framework/theme/common/ThemeRootProvider.tsx';

export function ThemeRootProvider(props: IThemeRootProviderProps) {
  return <>{props.children}</>;
}
